import { Box, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Button, Heading, MenuButton } from "../../components/Common";
import { NoRecordFound, Pagination, Search, TableLoader } from "../../components/Common/Table";
import { MdMoreVert, MdOutlineRemoveRedEye, MdClose } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineEdit } from "react-icons/ai";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useState,useEffect } from "react";
import useDebounce from "../../helper/utils";
import { useGetJobListQuery } from "../../services/Job";
import moment from "moment";
import { green, red, yellow, blue, grey, orange, purple, brown, pink, indigo } from '@mui/material/colors';

export default function JobMgt() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [currentType, setCurrentType] = useState(state);
    const [searchData, setSearchData] = useState('')
    const [selectedStatus, setSelectedStatus] = useState(null);
    const search = useDebounce(searchData, 500)
    useEffect(() => {
        setCurrentType(state);
        // ✅ When coming from "newJob", auto-select status 0 filter
        if (state === 'newJob') {
            setSelectedStatus(0);
        }
        else if (state === 'startJob') {
            setSelectedStatus(3);
        }
        else if (state === 'pendingJob') {
            setSelectedStatus(4);
        }
        else if (state === 'completedJob') {
            setSelectedStatus(5);
        }
        else if (state === 'clientCancelledJob') {  // Changed from 'clientcancellJob'
            setSelectedStatus(6);
        }
        else if (state === 'verifiedJob') {
            setSelectedStatus(7);
        }
        else if (state === 'employeeCancelledJob') {  // Changed from 'employeecancellJob'
            setSelectedStatus(8);
        }
        else {
            setSelectedStatus(null);
        }
    }, [state]);
    const statusOptions = [
        { value: 0, label: "Upcoming or Placed", color: grey[500] },
        { value: 1, label: "Assigned to Technician", color: blue[500] },
        { value: 9, label: "On Going", color: indigo[500] },
        { value: 2, label: "On the Way", color: yellow[700] },
        { value: 3, label: "Work in Progress", color: orange[500] },
        { value: 4, label: "Hold", color: brown[500] },
        { value: 5, label: "Completed", color: green[500] },
        { value: 6, label: "Client Cancelled", color: red[500] },
        { value: 7, label: "Verified", color: purple[500] },
        { value: 8, label: "Employee Cancelled", color: pink[500] },
        
    ];
    const { data, error, isLoading } = useGetJobListQuery({
        page: page + 1,
        search,
        orderStatus: selectedStatus,
        type: currentType  // Change from 'state' to 'currentType'
    });
    console.log('Full API Response:', data);
    console.log('API Error:', error);
    console.log('Is Loading:', isLoading);
    console.log('API Query params:', {
        page: page + 1,
        search,
        orderStatus: selectedStatus,
        type: state
    });
    const jobList = data?.data;
    const filteredJobList = jobList; 
    // Fallback client-side filter to handle cases where API ignores low status values.
    // Normalize to numbers in case API sends strings for some statuses.
   const handleStatusClick = (statusValue) => {
    console.log('Clicked status:', statusValue);
    setCurrentType(null);  // Clear dashboard filter
    setSelectedStatus(prev => prev === statusValue ? null : statusValue);
    setPage(0);
};

    const getStatusChip = (status) => {
        const statusOption = statusOptions.find(opt => opt.value === status);
        if (statusOption) {
            return <Chip size="small" label={statusOption.label} style={{ backgroundColor: statusOption.color, color: 'white' }} />;
        }
        return '-';
    };

    return (
        <>
            <Stack>
                <Heading head={'Jobs Management'} />
                <Stack my={1} flexDirection={{ xs: 'column-reverse', sm: 'row' }} gap={1} justifyContent={'space-between'} alignItems={{ xs: 'flex-end', sm: 'center' }}>
                    <Search setSearch={setSearchData} search={searchData} setPage={setPage} />
                    <Button buttonName='Add Jobs' onClick={() => navigate('/add-job')} />
                </Stack>
                <Stack
                    flexDirection={'row'}
                    gap={1}
                    flexWrap={'wrap'}
                    mb={2}
                    sx={{ overflowX: 'auto', pb: 1 }}
                >
                    {statusOptions.map((status) => (
                        <Box
                            key={status.value}
                            onClick={() => handleStatusClick(status.value)}
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.5,
                                px: 2,
                                py: 0.75,
                                borderRadius: '20px',
                                backgroundColor: selectedStatus === status.value ? status.color : 'transparent',
                                color: selectedStatus === status.value ? 'white' : status.color,
                                border: `2px solid ${status.color}`,
                                cursor: 'pointer',
                                fontSize: '13px',
                                fontWeight: 500,
                                transition: 'all 0.2s',
                                whiteSpace: 'nowrap',
                                '&:hover': {
                                    backgroundColor: selectedStatus === status.value ? status.color : `${status.color}15`,
                                }
                            }}
                        >
                            {status.label}
                            {selectedStatus === status.value && (
                                <MdClose
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedStatus(null); // SHOW ALL
                                        setCurrentType(null);  
                                        setPage(0);
                                    }}
                                    style={{ fontSize: '16px', marginLeft: '4px', cursor: 'pointer' }}
                                />
                            )}
                        </Box>
                    ))}
                </Stack>

            </Stack>
            <TableContainer component={Paper}>
                <Table stickyHeader aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Job ID</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Category Name</TableCell>
                            <TableCell>Client</TableCell>
                            <TableCell>Mobile</TableCell>
                            <TableCell>Technician Name</TableCell>
                            <TableCell>Technician Mobile</TableCell>
                            <TableCell>Complete OTP</TableCell>
                            <TableCell>Job Status</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading ? (<TableLoader colspan='11' />) :
                            filteredJobList && filteredJobList.length > 0 ?
                                (filteredJobList?.map((ele, i) => {
                                    const { orderNumber, orderDate, employeeName, employeeMobile, serviceDepartmentName, clientName, clientMobile, clientOtp, orderStatus } = ele;
                                    const formattedDate = moment(orderDate).format('DD-MM-YYYY');
                                    return (
                                        <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: 'pointer' }} onClick={() => navigate('/view-job', { state: { id: ele?.id, data: ele } })}>
                                            <TableCell>{i + 1}</TableCell>
                                            <TableCell>{orderNumber}</TableCell>
                                            <TableCell>{formattedDate}</TableCell>
                                            <TableCell>{serviceDepartmentName}</TableCell>
                                            <TableCell>{clientName}</TableCell>
                                            <TableCell>{clientMobile ? clientMobile : '-'}</TableCell>
                                            <TableCell>{employeeName ? employeeName : '-'}</TableCell>
                                            <TableCell>{employeeMobile ? employeeMobile : '-'}</TableCell>
                                            <TableCell>{clientOtp ? clientOtp : '-'}</TableCell>
                                            <TableCell>{getStatusChip(orderStatus)}</TableCell>
                                            <TableCell onClick={(e) => e.stopPropagation()}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                    <DropdownMenu.Root>
                                                        <DropdownMenu.Trigger className='dropDown'>
                                                            <MenuButton icon={<MdMoreVert style={{ color: '#000', fontSize: '18px' }} />} width='30px' height='33px' />
                                                        </DropdownMenu.Trigger>
                                                        <DropdownMenu.Content className='dropDownContent' align='end'>
                                                            <DropdownMenu.Item className='dropDownMenu' onClick={() => navigate('/edit-job', { state: { id: ele?.id, data: ele } })}>
                                                                <Stack flexDirection={'row'} gap={1} alignItems={'center'}><AiOutlineEdit style={{ fontSize: '15px' }} /><Box sx={{ fontSize: '13px' }}>Edit</Box></Stack>
                                                            </DropdownMenu.Item>
                                                            {/* <DropdownMenu.Item className='dropDownMenu' onClick={() => navigate('/view-job', { state: { id: ele?.id, data: ele } })}>
                                                                <Stack flexDirection={'row'} gap={1} alignItems={'center'}><MdOutlineRemoveRedEye style={{ fontSize: '15px' }} /><Box sx={{ fontSize: '13px' }}>View</Box></Stack>
                                                            </DropdownMenu.Item> */}
                                                        </DropdownMenu.Content>
                                                    </DropdownMenu.Root>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }))
                                : <NoRecordFound colspan='11' />
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {filteredJobList && filteredJobList.length > 0 ? <Pagination totalData={data?.totalData || 0} page={page} setPage={setPage} rowsPerPage={10} /> : ''}
        </>
    );
}
